import React, { useState } from "react";
import { Sparkles, Menu, X } from "lucide-react";

const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav
      className="relative sticky top-0 z-30 w-full md:w-2/3 border-b border-1 mt-4 border-gray-800 bg-white shadow-md rounded-full"
      role="fixed"
      aria-label="Main navigation"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <div className="flex items-center">
          <a
            href="/"
            aria-label="AI News - Home"
            className="flex items-center space-x-2"
          >
            <span className="font-bold text-xl text-blue-600 hover:text-blue-800 transition-colors duration-200">
              AI News
            </span>
          </a>
        </div>

        {/* Desktop Navigation Links */}
        <div className="hidden lg:flex items-center space-x-8">
          <a
            href="#how-it-works"
            className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium"
          >
            How it works{" "}
          </a>

          <a
            href="#sources"
            className="text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium"
          >
            Trusted Sources
          </a>
          <a
            href="/today"
            className="relative text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium group"
          >
            Today's AI News
            <span className="ml-1 text-blue-600 group-hover:animate-pulse">
              <Sparkles
                className="w-4 h-4 absolute -top-3 -right-7 group-hover:animate-pulse"
                fill="currentColor"
              />
            </span>
            <span className="absolute -top-3 -right-4 bg-blue-600 text-white text-xs px-1.5 py-0.5 rounded-full font-bold">
              NEW
            </span>
          </a>
        </div>

        {/* CTA Buttons & Mobile Menu Toggle */}
        <div className="flex items-center space-x-3 rounded-3xl">
          {/* Desktop Sign In */}
          <a
            href="/login"
            className="hidden lg:block bg-blue-600 text-white px-4 py-2 rounded-xl font-semibold border-1 border-black shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[1px] hover:translate-y-[1px] transition-all duration-200"
          >
            Sign In
          </a>

          {/* Mobile Menu Toggle */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-600" />
            ) : (
              <Menu className="w-6 h-6 text-gray-600" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg rounded-b-2xl">
          <div className="px-4 py-6 space-y-4">
            {/* Mobile Navigation Links */}
            <div className="space-y-3">
              <a
                href="#how-it-works"
                className="block text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium py-3 px-2 rounded-lg hover:bg-gray-50 min-h-[44px] flex items-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                How it works
              </a>

              <a
                href="#sources"
                className="block text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium py-3 px-2 rounded-lg hover:bg-gray-50 min-h-[44px] flex items-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Trusted Sources
              </a>

              <a
                href="/today"
                className="relative block text-gray-600 hover:text-blue-600 transition-colors duration-200 font-medium py-3 px-2 rounded-lg hover:bg-gray-50 min-h-[44px] flex items-center group"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="flex items-center w-full">
                  <span>Today's AI News</span>
                  <span className="ml-2 text-blue-600">
                    <Sparkles className="w-4 h-4" fill="currentColor" />
                  </span>
                  <span className="ml-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-bold">
                    NEW
                  </span>
                </div>
              </a>
            </div>

            {/* Mobile Sign In Button */}
            <div className="pt-4 border-t border-gray-200">
              <a
                href="/login"
                className="block w-full bg-blue-600 text-white px-4 py-4 rounded-xl font-semibold border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[1px] hover:translate-y-[1px] transition-all duration-200 text-center min-h-[48px] flex items-center justify-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Sign In
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
